import { create } from 'zustand'

/* Category functions */
const handleCheckCategory = (index, set) => {
  set((state) => {
    let newState = [...state.activeCategories.map(category => ({ ...category }))];
    newState[index].checked = !newState[index].checked;
    return { activeCategories: newState }
  })
}

const getSortedCategories = (headers, get) => {
  const sortedCategories = get(state => state.sortedCategories) || [];
  let newColumns = headers;
  if (sortedCategories.length) {
    newColumns = sortedCategories.map(cur => cur.active && headers.find(header => header.id === cur)).filter(cur => cur);
  }
  return newColumns;
}

const setSortedCategories = (categories, set) => {
  set((prevCategories) => {
    const newCategories = [...categories.map((category) => ({ ...category }))];
    return { sortedCategories: newCategories };
  })
}
/* End Category functions */


/* Vendor functions */
const handleCheckVendor = (index, set) => {
  set((state) => {
    let newState = [...state.activeVendors.map(vendor => ({ ...vendor }))];
    newState[index].checked = !newState[index].checked;
    return { activeVendors: newState }
  })
}

const getSortedVendors = (headers, get) => {
  const sortedVendors = get(state => state.sortedVendors) || [];
  let newColumns = headers;
  if (sortedVendors.length) {
    newColumns = sortedVendors.map(cur => cur.active && headers.find(header => header.id === cur)).filter(cur => cur);
  }
  return newColumns;
}

const setSortedVendors = (stations, set) => {
  set((prevStations) => {
    const newStations = [...stations.map((station) => ({ ...station }))];
    return { sortedVendors: newStations };
  })
}
/* End Vendor functions */

const useRepairDashboardStore = create((set, get) => ({
  activeCategories: [],
  setActiveCategories: (as) => set({ activeCategories: as }),
  handleCheckCategory: (index) => handleCheckCategory(index, set),
  sortedCategories: [],
  getSortedCategories: (headers) => getSortedCategories(headers, get),
  setSortedCategories: (categories) => setSortedCategories(categories, set),

  activeVendors: [],
  setActiveVendors: (as) => set({ activeVendors: as }),
  handleCheckVendor: (index) => handleCheckVendor(index, set),
  sortedVendors: [],
  getSortedVendors: (headers) => getSortedVendors(headers, get),
  setSortedVendors: (stations) => setSortedVendors(stations, set),
}))

export default useRepairDashboardStore;